import {d as m, o as f} from '@theme/global';
import '@theme/request-idle-callback';
class r extends HTMLElement {
  constructor() {
    super(),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.debouncedOnSubmit = m((n) => {
        this.onSubmitHandler(n);
      }, 500)),
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    const e = this.querySelector('#FacetsWrapperDesktop');
    e && e.addEventListener('keyup', f);
  }
  static setListeners() {
    const e = (n) => {
      const t = n.state ? n.state.searchParams : r.searchParamsInitial;
      t !== r.searchParamsPrev && r.renderPage(t, null, !1);
    };
    window.addEventListener('popstate', e);
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll('.js-facet-remove').forEach((n) => {
      n.classList.toggle('disabled', e);
    });
  }
  static renderPage(e, n, t = !0) {
    r.searchParamsPrev = e;
    const i = r.getSections(),
      s = document.getElementById('ProductCount'),
      l = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading'),
      s && s.classList.add('loading'),
      l && l.classList.add('loading'),
      i.forEach((d) => {
        const o = `${window.location.pathname}?section_id=${d.section}&${e}`,
          c = (u) => u.url === o;
        r.filterData.some(c) ? r.renderSectionFromCache(c, n) : r.renderSectionFromFetch(o, n);
      }),
      t && r.updateURLHash(e);
  }
  static renderSectionFromFetch(e, n) {
    fetch(e)
      .then((t) => t.text())
      .then((t) => {
        const i = t;
        (r.filterData = [...r.filterData, {html: i, url: e}]),
          r.renderFilters(i, n),
          r.renderProductGridContainer(i),
          r.renderProductCount(i);
      });
  }
  static renderSectionFromCache(e, n) {
    const t = r.filterData.find(e).html;
    r.renderFilters(t, n), r.renderProductGridContainer(t), r.renderProductCount(t);
  }
  static renderProductGridContainer(e) {
    (document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(e, 'text/html')
      .getElementById('ProductGridContainer').innerHTML),
      document.dispatchEvent(new CustomEvent('plp:grid-rendered'));
  }
  static renderProductCount(e) {
    const n = new DOMParser().parseFromString(e, 'text/html').getElementById('ProductCount').innerHTML,
      t = document.getElementById('ProductCount'),
      i = document.getElementById('ProductCountDesktop');
    (t.innerHTML = n), t.classList.remove('loading'), i && ((i.innerHTML = n), i.classList.remove('loading'));
  }
  static renderFilters(e, n) {
    const t = new DOMParser().parseFromString(e, 'text/html'),
      i = t.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'),
      s = (o) => {
        const c = n ? n.target.closest('.js-filter') : void 0;
        return c ? o.dataset.index === c.dataset.index : !1;
      },
      l = Array.from(i).filter((o) => !s(o)),
      d = Array.from(i).find(s);
    l.forEach((o) => {
      document.querySelector(`.js-filter[data-index="${o.dataset.index}"]`).innerHTML = o.innerHTML;
    }),
      r.renderActiveFacets(t),
      r.renderAdditionalElements(t),
      d && r.renderCounts(d, n.target.closest('.js-filter'));
  }
  static renderActiveFacets(e) {
    ['.active-facets-mobile', '.active-facets-desktop'].forEach((t) => {
      const i = e.querySelector(t);
      i && (document.querySelector(t).innerHTML = i.innerHTML);
    }),
      r.toggleActiveFacets(!1);
  }
  static renderAdditionalElements(e) {
    ['.mobile-facets__open', '.mobile-facets__count', '.sorting'].forEach((t) => {
      e.querySelector(t) && (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML);
    }),
      document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }
  static renderCounts(e, n) {
    const t = n.querySelector('.facets__selected');
    e.querySelector('.facets__selected') &&
      t &&
      (n.querySelector('.facets__selected').outerHTML = e.querySelector('.facets__selected').outerHTML);
  }
  static updateURLHash(e) {
    history.pushState({searchParams: e}, '', `${window.location.pathname}${e && '?'.concat(e)}`);
  }
  static getSections() {
    return [{section: document.getElementById('product-grid').dataset.id}];
  }
  onSubmitHandler(e) {
    e.preventDefault();
    const n = new FormData(e.target.closest('form')),
      t = new URLSearchParams(n).toString();
    r.renderPage(t, e);
  }
  onActiveFilterClick(e) {
    e.preventDefault(), r.toggleActiveFacets();
    const n =
      e.currentTarget.href.indexOf('?') === -1 ? '' : e.currentTarget.href.slice(e.currentTarget.href.indexOf('?') + 1);
    r.renderPage(n);
  }
}
r.filterData = [];
r.searchParamsInitial = window.location.search.slice(1);
r.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', r);
r.setListeners();
const h = () => {
  if (window.theme.autoApplyAvailabilityFilter !== !0) return;
  const a = new URLSearchParams(window.location.search),
    e = a.has('filter.v.availability');
  if ((window.location.pathname.includes('/collections/') || window.location.pathname.includes('/search')) && !e) {
    a.set('filter.v.availability', '1');
    const t = window.location.pathname + '?' + a.toString();
    window.location.replace(t);
  }
};
h();
class g extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll('input').forEach((e) => e.addEventListener('change', this.onRangeChange.bind(this))),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const e = this.querySelectorAll('input'),
      n = e[0],
      t = e[1];
    t.value && n.setAttribute('max', t.value),
      n.value && t.setAttribute('min', n.value),
      n.value === '' && t.setAttribute('min', 0),
      t.value === '' && n.setAttribute('max', t.getAttribute('max'));
  }
  adjustToValidValues(e) {
    const n = Number(e.value),
      t = Number(e.getAttribute('min')),
      i = Number(e.getAttribute('max'));
    n < t && (e.value = t), n > i && (e.value = i);
  }
}
customElements.define('price-range', g);
class p extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('a').addEventListener('click', (e) => {
        e.preventDefault(),
          (this.closest('facet-filters-form') || document.querySelector('facet-filters-form')).onActiveFilterClick(e);
      });
  }
}
customElements.define('facet-remove', p);
